<template>
    <transition name="fade" appear>
        <MoveWrap 
            :center="!position" 
            v-if="exist" 
            v-show="show" 
            :variable="!unvariable" 
            :large="large" 
            :resizeData="resizeData"
            :style="init_style" 
        >
            <div :class="['_layer_wrap',{ unframe }]">
                <MoveTarget v-if="!unframe" >
                    <div class="header" @dblclick="!unvariable && (large = !large)">
                        <div class="title">
                            <component v-if="isVNode(i_pop.title)" :is="{render: h=>i_pop.title}"></component>
                            <template  v-else>
                                {{ i_pop.title }}
                            </template>
                        </div>
                        <div class="buttonss" @mousedown.stop>
                            <div class="button" :class="[large?'small':'large']" @click="!unvariable && (large = !large)"></div>
                        </div>
                        <div class="buttons" @mousedown.stop>
                            <div class="button close" @click="closeButton"></div>
                        </div>
                    </div>
                </MoveTarget>
                <div class="_content" ref="_content">
                    <component :is="i_pop.component" v-bind.sync="i_props" v-on="i_ons" ref="target"/>
                </div>
            </div>
        </MoveWrap>  
    </transition>
</template>

<script>
import { isVNode } from './utils';
import MoveWrap from './components/MoveWrap'
import MoveTarget from './components/MoveTarget'
export default { 
    name: "box",
    components: {
        MoveWrap,MoveTarget
    },
    props: {
        // 弹窗显示隐藏
        show: Boolean,
        // 传给子组件的数据集合
        props: Object,
        // 标题
        title: [String,Object],
        // layout容器resize后的宽高数据
        resizeData: Object,
        // 默认宽度
        width: {
            type: [Number,String],
            default: 'auto'
        },
        // 默认高度
        height: {
            type: [Number,String],
            default: 'auto'
        },
        // 默认最小宽度
        minWidth: {
            type: [Number,String],
            default: 300
        },
        // 默认最小高度
        minHeight: {
            type: [Number,String],
            default: 100
        },
        // 设置为 true 时可以创建一个无边框窗口
        unframe: Boolean,
        // 绝对定位
        position: Object,
        // 组件
        component: Object,
        // 禁用改变窗口大小 
        unvariable: Boolean
    },
    data() {
        return {
            // 弹窗是否存在
            exist: false,
            large: false,
            i_pop: {
                title: '',
                component: null,
                close: null
            },
            i_props: {},
            i_ons: {}
        }
    },
    computed: {
        init_style() {
            const filter = (v = 0) => {
                let cons = v.constructor
                if (cons == Number)
                    return v + 'px'
                else if (cons == String){
                    if (v.indexOf('%') != -1)
                        return v
                    else if (v.indexOf('px') != -1)
                        return v
                    else 
                        return v
                }
            };

            let style = {
                width: filter(this.width),
                height: filter(this.height),
                minWidth: filter(this.minWidth),
                minHeight: filter(this.minHeight)
            }

            let p = this.position

            if (p) {
                style.top = p.hasOwnProperty('top') ? p.top : 'auto'
                style.left = p.hasOwnProperty('left') ? p.left : 'auto'
                style.right = p.hasOwnProperty('right') ? p.right : 'auto'
                style.bottom = p.hasOwnProperty('bottom') ? p.bottom : 'auto'
            }

            return style
        }
    },
    watch:{
        // 组件初始化
        component:{
            handler(component) {
                this.i_props = {
                    show: this.show,
                    ...this.props
                }

                let i_pop = this.i_pop

                this.title && (i_pop.title = this.title)

                this.i_ons = this._events

                this.$_onButtons = {
                    onCloseButton: null
                };

                let self = this;

                let beforeCreate = [...(component.beforeCreate || []),function(){
                    this.$thisFrame = {
                        close: self.close,
                        watchShow: fn=>self.watchShow = fn,
                        onButtons: self.$_onButtons,
                    }
                }]

                // 拷贝
                component = {...component}

                component.beforeCreate = beforeCreate

                i_pop.component = component

            },
            immediate: true
        },
        show(...args){
            this.watchShow && this.watchShow(...args)
        }
    },
    methods: {
        /**
         * 关闭方法
         * force 是否强制关闭
         * id 用于判断调用关闭方法的来源 传给onClose回调
         */
        close (force,id){
            (force || !this._events.onClose) ? this.forceClose() : this.$emit('onClose',id)
        },
        forceClose() {
            this.exist = false
        },
        closeButton() {

            let onCloseButton = this.$_onButtons.onCloseButton

            if (onCloseButton && onCloseButton.constructor === Function) {

                if (onCloseButton() === false) 
                    return
            }

            this.close(false,'closeButton')
        },
        isVNode
    }
}
</script>

<style scoped>

    ._layer_wrap {
        height: 100% ;
        box-sizing: border-box;
        border: 1px solid black;
        box-shadow: 0 0 0 1px black, 0 2px 8px rgba(0, 0, 0, .4);
        border-radius: 3px;
        /* background: #1C1F39; */
        display: flex;
        flex-direction: column;
    }

    ._layer_wrap.unframe {
        border: none;
        box-shadow: none;
    }

    .header {
        height: 36px;

        border-bottom: 1px solid black;
        color: #fff;

        position: relative;
        background: black;
    }

    ._content {
        overflow: hidden;
        height: 100%;
        position: relative;
    }

    .buttons {
        top: 0;
        right: 1px;
        position: absolute;

        overflow: hidden;
        display: flex;
    }
    .buttonss {
        top: 0;
        right: 45px;
        position: absolute;

        overflow: hidden;
        display: flex;
    }
    .button {
        width: 43px;
        height: 34px;
        margin-top: 1px;
        transition: background-color .08s;
        border-radius: 2px;
        cursor: pointer;
    }
    .large {
        background: url(./assets/c01.png) no-repeat center;
        background-size: 11px;
    }
    .small {
        background: url(./assets/c02.png) no-repeat center;
        background-size: 11px;
    }
    .close {
        background: url(./assets/b01.png) no-repeat center;
        background-size: 11px;
    }

    /* .button.close:hover {
        background: url(./assets/close-active.svg) #a42d34 no-repeat center;
        background-size: 11px;
    } */

    .title {
        padding: 10px;
        font-size: 14px;
        color: #bedaff;
        text-align: left;
        cursor: default;
        user-select: none;
    }

    .fade-leave-active,
    .fade-enter-active {
        transition: opacity .18s, transform .18s;
        opacity: 1;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
        transform: translate3d(0, 20px, -45px) rotateX(-4deg);
    }

    .hide {
        opacity: 0;
    }

</style>
